module.exports = __webpack_public_path__ + "static/ribbon-1dfdc4af0329d57a67092a00a38e50fe.png";